module.exports = __webpack_public_path__ + "img/画板 19.bb190ef4.jpg";